import { useRef } from 'react'

import { FormFilter } from '@/compositions/form-filters-report'
import { FormFilterRef } from '@/compositions/form-filters-report/ref'
import { ReportList } from '@/compositions/report-list'
import { useReportContext } from '@/contexts/report.context'

const ReportView = () => {
  const filterFormRef = useRef<FormFilterRef>(null)

  const { setTableData, handleFilter, handleShowReports } = useReportContext()

  const handleClearForm = () => {
    if (filterFormRef.current) {
      filterFormRef.current.clearForm()
      setTableData([])
    }
  }

  return (
    <>
      <FormFilter
        ref={filterFormRef}
        onFilters={handleFilter}
        onClear={handleClearForm}
        onShowReports={handleShowReports}
      />

      <ReportList />
    </>
  )
}

export default ReportView
